import React, { useEffect, useState } from "react";
import {
  View,
  Modal,
  TouchableOpacity,
  StyleSheet,Image,Linking
} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from 'rn-responsive-styles'
import CustomButton from "./CustomButton";
import CImage from "./CImage";
import { useLocation } from "react-router-dom";
import AsyncStorageFunc from '../utilities/asyncStorage';
import { getUserConfigAtHome } from "../api/apiManager";
import RootNavigation from "../utilities/RootNavigation";

const CWelcomePopup = () => {

  const screenEvents = {
    Dashboard: 'Dashboard',
    Help: 'Faq',
    Profile: 'Profile',
    ServiceRequest: 'SelfService',
    // ServiceRequest: 'ServiceRequest',
    Statement: 'Statement',
    Recharge: 'Recharge',
    Dispute: 'MyDispute',
    Transfer: 'PoolAccount',
    PoolAccount: 'PoolAccount',
    Fuel: 'FuelPayment',
    MyVehicles: 'MyVehicles',
    AddVehicle: 'AddVehicle',
    insurance: 'TripInsurance',
    UsedCarLoan: 'UsedCarLoan',
    maxpro: 'FastagMax',
    VehicleDetails: 'VehicleDetails',
    MobileUpdate :"ServiceRequest",
    KycUpdate :"ServiceRequest",
    RcUpdate :"ServiceRequest",
    SelectVehicleForTagClosure :"ServiceRequest"

  }

const styles = useStyles();
const [userHomeConfig, setUserHomeConfig] = useState({});
const [screenEventName, setScreenEventName] = useState("");
const [isWelcomeModal, setIsWelcomeModal] = useState(false);
const location = useLocation()

useEffect(() => {
  
  const getUserPopupConfig = async (eventName) => {
    const useerID = global.userCd || "login"
    const POPUP_CONFIG = `popupConfig_${useerID}`;
    const storedAsyncData = await AsyncStorageFunc.getData(POPUP_CONFIG);
    const storedData = storedAsyncData ? [...storedAsyncData] : [];
    const index = storedData.findIndex((item) => item.event === eventName);
    const currentDate = new Date().toLocaleDateString();
    console.log('currentDate:', currentDate,index,storedAsyncData);
    
    if (index === -1 || (index > -1 && storedData[index].date !== currentDate)) {
      getUserConfigAtHome({ configType: "WELCOME", event: eventName }).then(async (resObj) => {
        console.log('getUserConfigForPopup:', resObj);
        if(resObj && resObj?.showConfig){
          setUserHomeConfig(resObj);
          const updatedConfig = {event : resObj?.event, showConfig:resObj?.showConfig, date: currentDate };
          if (index > -1) {
            storedData[index] = updatedConfig;
          } else {
            storedData.push(updatedConfig);
          }
          await AsyncStorageFunc.storeData(POPUP_CONFIG, storedData);
        }
      }).catch((err) => {
        // console.log('getUserConfigAtHome err', err);
        setIsWelcomeModal(false);
      });
    }else{setIsWelcomeModal(false)} 
  }
  const configEventsArr = (global.welcomeConfigEvents) ? global.welcomeConfigEvents : [];
  const url = location.pathname.split('/');
  let currentScreenName = url[1]
  if(url[2]){currentScreenName = url[2]}
  if(url[3]){currentScreenName = url[3]}
  if (currentScreenName && screenEvents.hasOwnProperty(currentScreenName)) {
    const eventName = screenEvents[currentScreenName];
    if (configEventsArr.includes(eventName)) {
      setScreenEventName(eventName);
      getUserPopupConfig(eventName);
    }
    console.log("currentScreenEventName", `${eventName}`);
  }
}, [location]);


useEffect(() => {
  if (userHomeConfig && userHomeConfig?.showConfig && userHomeConfig?.imageMobile) {
    // console.log(userHomeConfig,"userHomeConfig")
    setIsWelcomeModal(true);
  }
}, [userHomeConfig]);

const onCloseModal = async()=>{
  // const useerID = global.userCd || "login"
  // const POPUP_CONFIG = `popupConfig_${useerID}`;
  // await AsyncStorageFunc.deleteData(POPUP_CONFIG);
  setIsWelcomeModal(false)
}

const isValidUrlStrong = (urlString) => {
  const urlPattern = new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?");
  return !!urlPattern.test(urlString);
}

const onPressBanner = () => {
  setIsWelcomeModal(false);
  global.showConfig = false
  if (userHomeConfig && userHomeConfig?.imageMobile && userHomeConfig?.url) {
    const dataUrl = userHomeConfig?.url;
    if (isValidUrlStrong(dataUrl)) {
      Linking.openURL(dataUrl);
    } else {
      const matches = dataUrl.split(";");
      console.log(matches, 'matches1')
      if (matches && matches[1] && matches[1] == "UsedCarLoan") {
        RootNavigation.navigate("OtherServices/UsedCarLoan", { screen: "alignedServices", })
        global.activeScreen = "OtherServices"
      } else if (matches[1] == "TripInsurance") {
        RootNavigation.navigate("OtherServices/insurance", { screen: "", })
        global.activeScreen = "OtherServices"
      } else if (matches[1] == "Dashboard") {
        RootNavigation.navigate("Dashboard")
        global.activeScreen = "Dashboard"
      } else if (matches[1] == "Maxpro") {
        RootNavigation.navigate("OtherServices/maxpro")
        global.activeScreen = "OtherServices"
      } else if (matches[1] == "ServiceRequest") {
        RootNavigation.navigate("ServiceRequest")
        global.activeScreen = "ServiceRequest"
      } else {
        RootNavigation.navigate("Home", { screen: matches[1] });
      }
    }
  }
}

  return (
    <Modal
      animationType={"fade"}
      visible={isWelcomeModal}
      transparent={true}
      // onRequestClose={() => onCloseModal()}
    >
     <TouchableOpacity style={styles.overlayContainer} >
        <View style={styles.overlay}></View>
       
        <View style={styles.modalContainer}>
          <View style={styles.modalBody}>
            <TouchableOpacity style={styles.closeBtnWidget} onPress={() => onCloseModal()}>
              <CImage.CloseIcon1></CImage.CloseIcon1>
            </TouchableOpacity>
            <TouchableOpacity style={{  }} onPress={() => onPressBanner()}>
              {userHomeConfig?.imageMobile && <Image
                resizeMode="contain"
                style={styles.imageStyle}
                source={{ uri: `data:image/png;base64,${ userHomeConfig?.imageMobile}` }}
              /> }
              {/* <Image
                resizeMode="contain"
                style={styles.imageStyle}
                source={{ uri: `data:image/png;base64,${ userHomeConfig?.imageMobile}` }}
              /> */}
            </TouchableOpacity>
            <View style={styles.btnWidget}>
              <CustomButton
                onPress={() => onPressBanner()}
                text={"PROCEED"}
              />
            </View>
           
          </View>
          
        </View>
        </TouchableOpacity>
      
    </Modal>
  );
};

export default CWelcomePopup;

const useStyles = CreateResponsiveStyle(
  {
    overlayContainer: {
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.7)",
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      zIndex: 99,
    },
    modalContainer: {
      height: "100%",
      width: "100%",
      position: "absolute",
      alignItems: "center",
      justifyContent: "center",
      zIndex:999
    },
    modalBody: {
      width: "90%",
      height: "100%",
      alignSelf: "center",
      borderRadius: 10,
      alignItems: "center",
      justifyContent: "center"
    },
    imageStyle:{ 
      width: 450,
      height: 450, 
      borderRadius: 10, 
      margin: 0, 
      padding: 0,
      alignSelf:'center',
      // marginTop:'-10%'
    },
    btnWidget:{
      width:400,
      marginTop:15,
      height:40
    },
    closeBtnWidget:{
      marginLeft:455
    }
   
   
  },

  {
    [DEVICE_SIZES.LG]: {
      

    },
    [DEVICE_SIZES.MD]: {
      
    },
    [DEVICE_SIZES.SM]: {
      
      imageStyle:{ 
        width: 320,
        height: 320, 
      },
      btnWidget:{
        width:300,
      },
      closeBtnWidget:{
        marginLeft:325
      }
    },
    [DEVICE_SIZES.XS]: {
      btnWidget:{
        width:200,
      },
      imageStyle:{ 
        width: 250,
        height: 250,
      },
      closeBtnWidget:{
        marginLeft:255
      }

    },
  }
);

const styles = StyleSheet.create({
  
});

